import http from "./httpList";
import common from "./common";
import motheds from "./motheds";
import popup from "./popup";
//微信分享
function wxtools() {
  return {
    uploadUserinfo(data){
      if (!motheds.tools().isWeiXin()) {
        return;
      }
      this.wxmplogin(data,(userInfo)=>{
        http.getHttp({
          url: '/app/visitor/uploadVisitorRecord',
          type: "put",
          hideAlert:true,
          params: {
            type:"4",
            typeUrl:location.href,
            mechanCode:motheds.codeLink(),
            nickname: userInfo.nickname || '微信访客',
            imgUrl: userInfo.headimgurl,
            openId: userInfo.openid,
            name:data.title,
            typeImg:data.typeImg||'https://www.fxyf99.com/upload/FILE/20210623/20210623092431460.png',
          }
        },(res) => {

        })
      })
    },
    // 获取微信用户信息
    wxmplogin: function(params, callback) {
      if (!motheds.tools().isWeiXin()) {
        callback && callback({});
        return;
      }
      if (localStorage.openid && localStorage.wxInfo) {
        let userInfo = {};
        try {
          userInfo = JSON.parse(localStorage.wxInfo);
        } catch (e) {
          console.log("读取本地微信用户信息失败", e);
        }
        userInfo.openid = localStorage.openid;
        if (userInfo.hasOwnProperty("nickname")) {
          callback && callback(userInfo);
          return;
        }
      }
      const PARAMS = {
        appid: this.getWxId(),
        url: "/msg/center/get/code2Info"
      };
      Object.assign(PARAMS, params);
      var code = motheds.tools().getQueryString("code");
      var state = motheds.tools().getQueryString("state");
      if (!code) {
        var redirect_url = this.wechat_redirect_url(PARAMS); //获取授权地址
        location.href = redirect_url;
      } else {
        http.getHttp({
          url: PARAMS.url,
          type: "get",
          params: {
            code: code,
            state: state,
            appid: PARAMS.appid
          }
        },(result, er) => {
          if (result.msg == "重复CODE请求" || result.httpCode == 409) {
            var tempHref = location.href;
            tempHref = motheds.tools().delQueStr(tempHref, "code");
            tempHref = motheds.tools().delQueStr(tempHref, "state");
            window.location.replace(tempHref);
            return;
          }
          if (
            (!result.hasOwnProperty("data") ||
              !result.data.hasOwnProperty("nickname")) &&
            state == "snsapi_base"
          ) {
            PARAMS.openModal = true;
            var redirect_url = this.wechat_redirect_url(PARAMS); //获取授权地址
            window.location.replace(redirect_url);
            return;
          }
          if (
            result != null &&
            result.httpCode == 200 &&
            result.hasOwnProperty("data") &&
            result.data != ""
          ) {
            if (result.data.openid) {
              localStorage.setItem("openid", result.data.openid);
              localStorage.setItem("wxInfo", JSON.stringify(result.data));
            }
            callback && callback(result.data);
          }
        });
      }
    },
    //获取微信授权地址
    wechat_redirect_url: function(params) {
      var wxappid = params.appid; //appid
      var fromurl = "";
      var tempHref = location.href;
      var authText = "snsapi_userinfo";
      // var authText = "snsapi_base";
      // if(params.openModal){
      //     authText = "snsapi_userinfo";
      // }
      tempHref = motheds.tools().delQueStr(tempHref, "code");
      tempHref = motheds.tools().delQueStr(tempHref, "state");
      //如果当前访问域名不在安全域名内,则跳转到个人中心的登录跳转页
      fromurl = encodeURIComponent(tempHref);
      var url =
        "https://open.weixin.qq.com/connect/oauth2/authorize?appid=" +
        wxappid +
        "&redirect_uri=" +
        fromurl +
        "&response_type=code&scope=" +
        authText +
        "&state=" +
        authText +
        "#wechat_redirect";
      return url;
    },
    shareWx: function(title, img, desc, url1, types) {
      //types-分享成功后回调
      if (!motheds.tools().isWeiXin()) return;
      // if(url1){
      //     url1 = "/fxyf/jump.html?p="+url1;
      // }
      var appId = this.getWxId();
      var title = title;
      var url = location.href.split("#")[0];
      // 调用服务器获取签名
      http.getHttp(
        {
          name: "jssdksign",
          params: {
            appid: appId,
            url: url
          }
        },
        data => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId + "", // 必填，公众号的唯一标识
            timestamp: data.sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.sign.noncestr, // 必填，生成签名的随机串
            signature: data.sign.signature + "", // 必填，签名，见附录1
            jsApiList: [
              "onMenuShareTimeline",
              "onMenuShareAppMessage",
              "onMenuShareQQ",
              "translateVoice"
            ] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function() {
            //分享到朋友圈
            wx.onMenuShareTimeline({
              title: title,
              desc: desc,
              link: url1,
              imgUrl: img,
              success: function() {},
              cancel: function() {
                popup.msg("取消分享！");
              },
              fail: function(res) {
                alert(JSON.stringify(res));
              }
            });
            //分享给朋友
            wx.onMenuShareAppMessage({
              title: title,
              desc: desc,
              link: url1,
              imgUrl: img,
              trigger: function(res) {},
              success: function(res) {},
              cancel: function(res) {
                popup.msg("已取消！");
              },
              fail: function(res) {
                alert(JSON.stringify(res));
              }
            });
            //alert('已注册获取“发送给朋友”状态事件');
          });

          wx.error(function(res) {
            console.log(res);
          });
        }
      );
    },
    hideMenu() {
      //隐藏微信地址栏自带工具栏
      if (!motheds.tools().isWeiXin()) return;
      var appId = this.getWxId();
      var url = location.href.split("#")[0];
      // 调用服务器获取签名
      http.getHttp(
        {
          name: "jssdksign",
          params: {
            appid: appId,
            url: url
          }
        },
        data => {
          wx.config({
            debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
            appId: appId + "", // 必填，公众号的唯一标识
            timestamp: data.sign.timestamp, // 必填，生成签名的时间戳
            nonceStr: data.sign.noncestr, // 必填，生成签名的随机串
            signature: data.sign.signature + "", // 必填，签名，见附录1
            jsApiList: ["hideMenuItems"] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
          });
          wx.ready(function() {
            wx.hideMenuItems({
              menuList: [
                "menuItem:share:timeline", // 复制链接
                "menuItem:share:appMessage", // 发送给朋友
                "menuItem:share:qq", // 分享到QQ
                "menuItem:share:weiboApp", // 分享到Weibo
                "menuItem:favorite", // 收藏
                "menuItem:share:facebook", // 分享到FB
                "menuItem:share:QZone", // 分享到 QQ 空间
                "menuItem:editTag", // 编辑标签
                "menuItem:delete", // 删除
                "menuItem:copyUrl", // 复制链接
                "menuItem:readMode", // 阅读模式:
                "menuItem:share:email" //邮件
              ],
              success: function(res) {
                console.log(
                  "已隐藏“阅读模式”，“分享到朋友圈”，“复制链接”等按钮"
                );
              },
              fail: function(res) {
                console.log(res);
                // alert(JSON.stringify(res));
              }
            });
          });

          wx.error(function(res) {
            console.log(res);
          });
        }
      );
    },
    getWxId: function() {
      var wxappid = "wx9aa0e91be989a713"; //蜡烛科技产品测试
      if (common.env == 1) {
        wxappid = "wx1a86bb7e7f5e7797"; //保险服务助手
      } else if (common.env == 4) {
        // wxappid = "wx3571834748e0b0d6"; //儿童险投保攻略
        wxappid = "wx1a86bb7e7f5e7797"; //保险服务助手
      }
      return wxappid;
    }
  };
}

export default wxtools;



// WEBPACK FOOTER //
// ./src/api/wx.js